import { EventService } from './event/event.service'
import { TournamentService } from './tournament/tournament.service'
import { AnalyticService } from './google/analytic.service'
import { PaymentService } from './payment/payment.service'
import { TaxonomyService } from './taxonomy/taxonomy.service'
import { RegisterService } from './auth/register.service'
import { AthleteService } from './athlete/athlete.service'
import { TeamService } from './team/team.service'
import { MemberService } from './member/member.service'
import { AuthService } from './auth/auth.service'
import { DisposableTokensService } from './auth/disposableTokens.service'
import { TriggerService } from './trigger/trigger.service'
import { StatisticsService } from './statistics/statistics.service'
import { SponsorsService } from './sponsors/sponsors.service'
import { BeneficiaryService } from './beneficiary/beneficiary.service'
import { FollowerService } from './follower/follower.service'

import { JurisdictionsService } from './jurisdictions/jurisdictions.service'
import { PreRegistrationService } from './preRegistrationService/preRegistrationService.service'
import { PreRegistrationPublicService } from './public/preRegistrationPublic.service'

import { AdminMemberService } from './admin/admin-member.service'
import { AdminTournamentService } from './admin/admin-tournament.service'
import { AdminTriggerService } from './admin/admin-trigger.service'
import { AdminTaxonomyService } from './admin/admin-taxonomy.service'
import { AdminAthletesService } from './admin/admin-athlete.service'
import { AdminTeamsService } from './admin/admin-team.service'
import { AdminSponsorsService } from './admin/admin-sponsor.service'
import { AdminEventService } from './admin/admin-event.service'
import { AdminMemberInvoiceService } from './admin/admin-invoice.service'
import { AdminBeneficiariesService } from './admin/admin-beneficiaries.service'
import { AdminInWinsService } from './admin/admin-in-win.service'

export default {
  athleteService: AthleteService.create(),
  authService: AuthService.create(),
  disposableTokensService: DisposableTokensService.create(),
  eventService: EventService.create(),
  memberService: MemberService.create(),
  adminAthletesService: AdminAthletesService.create(),
  adminSponsorsService: AdminSponsorsService.create(),
  paymentService: PaymentService.create(),
  registerService: RegisterService.create(),
  analyticService: AnalyticService.create(window.ga),
  tournamentService: TournamentService.create(),
  taxonomyService: TaxonomyService.create(),
  teamService: TeamService.create(),
  triggerService: TriggerService.create(),
  sponsorsService: SponsorsService.create(),
  beneficiaryService: BeneficiaryService.create(),
  followerService: FollowerService.create(),
  jurisdictionsService: JurisdictionsService.create(),
  preRegistrationService: PreRegistrationService.create(),
  preRegistrationPublicService: PreRegistrationPublicService.create(),

  statisticsService: StatisticsService.create(),

  adminTaxonomyService: AdminTaxonomyService.create(),
  adminMemberService: AdminMemberService.create(),
  adminTriggerService: AdminTriggerService.create(),
  adminTournamentService: AdminTournamentService.create(),
  adminTeamsService: AdminTeamsService.create(),
  adminEventService: AdminEventService.create(),
  adminMemberInvoiceService: AdminMemberInvoiceService.create(),
  adminBeneficiariesService: AdminBeneficiariesService.create(),
  adminInWinsService: AdminInWinsService.create(),
}
